<swiper class="dot-slider"
[allowSlidePrev]="false"
[config]="{
    slidesPerView: 3,
    spaceBetween: 0,
    slideClass:'dot-slide'
}">
    <ng-template swiperSlide *ngFor="let dot of [].constructor(length);let i = index">
        <img *ngIf="i !== indexActive" src="assets/icons/slider-dot.svg" alt="">
        <img *ngIf="i === indexActive" src="assets/icons/slider-dot-active.svg" alt="">
    </ng-template>
    
</swiper>
